function smoothScroll() {
  $('a.anchor').click(function(e){
      e.preventDefault();
      $('html, body').animate({
          scrollTop: $( $.attr(this, 'href') ).offset().top-100
      }, 500);
  });
}

export default smoothScroll
